module.exports = __webpack_public_path__ + "media/assets/HWE_culinary_experience-35b1ba30f7f2ca097fb37b540ef3a235.jpg";